'use client';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export interface BlockNameInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  id?: string;
  className?: string;
}

const DEFAULT_PLACEHOLDER = 'Ej: Horarios Fin de Semana';

export function BlockNameInput({
  value,
  onChange,
  error,
  placeholder = DEFAULT_PLACEHOLDER,
  id = 'block-name',
  className,
}: BlockNameInputProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <Label htmlFor={id}>Nombre del bloque de horario</Label>
      <Input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className={cn(
          'transition-colors',
          error && 'border-destructive focus-visible:ring-destructive',
        )}
      />
      {error && (
        <p id={`${id}-error`} className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
